import { gql } from '@apollo/client';

export const ADD_OUTCOMES_TO_INTERVENTION = gql`
  mutation addOutcomesToIntervention($input: AddOutcomesToInterventionInput!) {
    intervention: addOutcomesToIntervention(input: $input) {
      id
    }
  }
`;
